import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../AuthContext';
import { Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { FaFacebook, FaMoon } from 'react-icons/fa';
import { BiLogoDiscord } from 'react-icons/bi';
import { FaSquareInstagram } from 'react-icons/fa6';
import { IoLogoDiscord } from 'react-icons/io5';
import logo from './logo.jpg'
import { IoIosSunny, IoMdClose, IoMdDownload, IoMdMenu } from 'react-icons/io';
import './NLayout.css'
import logoFooter from './serendepia2.png'
import { TbLogout2 } from 'react-icons/tb';
import { AiOutlineSetting, AiOutlineUser } from 'react-icons/ai';
import { GrGallery } from 'react-icons/gr';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import axios from 'axios';
import config from '../../config';



function Nlayout(props) {
    const { user } = useContext(AuthContext);
    const [modoOscuro, setModoOscuro] = useState(() => {
        const guardado = localStorage.getItem('modoOscuro');
        return guardado ? JSON.parse(guardado) : false;
    });

    useEffect(() => {
        localStorage.setItem('modoOscuro', JSON.stringify(modoOscuro));

        // Cambiar fondo del root
        const root = document.getElementById('root');
        const pElements = document.getElementsByTagName('p');
        for (let el of pElements) {
            el.style.color = modoOscuro ? '#fff ' : '#000 '
        }
        const h3Elements = document.getElementsByTagName('h3');
        for (let el of h3Elements) {
            el.style.color = modoOscuro ? '#fff ' : '#000 '
        }
        if (root) {
            root.style.backgroundColor = modoOscuro ? 'black' : '#ffffff';
            root.style.color = modoOscuro ? '#fff ' : '#000 ';
            root.style.transition = 'background-color 0.3s ease';

        }
    }, [modoOscuro]);

    const [subMenu, setSubMenu] = useState(false);
    const [esClick, setEsClick] = useState(false);
    const [imagenes, setImagenes] = useState([])

    const habilitarSubMenu = (valor, e) => {
        if (e?.type === "click") {
            setEsClick(true);
        } else {
            setEsClick(false);
        }
        setTimeout(() => {
            setSubMenu(valor);
        }, [100]);
    };
    useEffect(() => {
        const handleClickOutside = () => {
            setSubMenu(false);
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    const handleLogout = async () => {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("account");
        window.location.href = "/";
    };
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMobileMenu = () => setMenuOpen(!menuOpen);

    const ObtenerImagenes = async () => {
        try {
            const response = await axios.get(`https://backmu.vercel.app/guardar-imagen`)

            setImagenes(response.data)
        } catch (err) {

        }
    }

    useEffect(() => {
        ObtenerImagenes()
    }, [])
    const [generalData, setGeneralData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${config.apiBaseUrl}/info`);
                const data = await response.json();
                setGeneralData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setGeneralData(null);
            } finally {

            }
        };
        fetchData();
    }, []);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openImage = (url) => {
        setSelectedImage(url);
        setIsOpen(true);
    };

    const closeImage = () => {
        setIsOpen(false);
        setSelectedImage(null);
    };

    return (
        <Grid container spacing={3} justifyContent="center" sx={{ maxWidth: props.isMobile ? '100%' : 1200, mx: 'auto', p: props.isMobile ? 1 : 3, mt: 1, backgroundColor: modoOscuro ? 'black' : 'white' }}>


            <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'white', width: '100%', padding: 5, borderRadius: 5, boxShadow: '0 2px 4px rgba(0,0,0,0.1)', backgroundColor: modoOscuro ? 'black' : 'white' }}>

                <Grid style={{ display: 'flex', alignItems: 'center', gap: 5 }}>

                    <Link
                        style={{ textDecoration: "none", padding: 0 }}
                        to="/descargas"
                    >
                        <Grid
                            style={{
                                height: "3rem",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: ".5rem",
                                paddingRight: ".5rem",
                                paddingTop: ".3rem",
                                paddingBottom: ".3rem",
                                borderRadius: ".375rem",
                                width: "100%",
                                justifyContent: "center",
                                animation: !props.tyExpanded && "ease-in-out 1.5s linear",
                                backgroundColor: '#cd1009'
                            }}
                            className='boton-descarga'

                        >
                            {
                                props.isMobile ? <IoMdDownload style={{ color: 'white', fontSize: 24 }} /> :
                                    <span
                                        style={{
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            color: 'white',
                                            fontFamily: 'poppins'
                                        }}

                                    >
                                        DESCARGAR MU SERENDIPIA!
                                    </span>
                            }

                        </Grid>
                    </Link>


                    <ul
                        style={{
                            display: props.isMobile ? (menuOpen ? 'flex' : 'none') : 'flex',
                            flexDirection: props.isMobile ? 'column' : 'row',
                            gap: props.isMobile ? 10 : 5,
                            listStyle: 'none',
                            margin: 0,
                            padding: 10,
                            alignItems: 'center',
                            backgroundColor: props.isMobile ? '#f9f9f9' : 'transparent',
                            position: props.isMobile ? 'absolute' : 'static',
                            top: props.isMobile ? '60px' : 'auto',
                            right: props.isMobile ? 0 : 'auto',
                            zIndex: 1000,
                            width: props.isMobile ? '100%' : 'auto',
                            boxShadow: props.isMobile ? '0 4px 6px rgba(0,0,0,0.1)' : 'none',
                        }}
                    >
                        <li>
                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                to="/"
                            >
                                <Typography style={{ fontSize: 12, color:'#000', fontWeight:500 , fontFamily: 'poppins', whiteSpace:'nowrap'}}>Inicio</Typography>
                            </Link>
                        </li>

                        <li style={{ position: 'relative' }}>
                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                to="/rankings"
                            >
                                <Typography style={{ fontSize: 12 , color:'#000', fontWeight:500, fontFamily: 'poppins', whiteSpace:'nowrap'}}>Rankings</Typography>
                            </Link>

                            {/* Submenú */}
                            <ul style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                backgroundColor: '#fff',
                                padding: '10px',
                                listStyle: 'none',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                display: 'none',
                                flexDirection: 'column',
                                zIndex: 1000
                            }} className="submenu">
                                <li><Link to="/rankings/online" style={{ textDecoration: 'none', color: 'inherit' }}>Online</Link></li>
                                <li><Link to="/rankings/resets" style={{ textDecoration: 'none', color: 'inherit' }}>Resets</Link></li>
                                <li><Link to="/rankings/salon-de-la-fama" style={{ textDecoration: 'none', color: 'inherit' }}>Salón de la Fama</Link></li>
                                <li><Link to="/rankings/phonomanias" style={{ textDecoration: 'none', color: 'inherit' }}>Phonomanias</Link></li>
                                <li><Link to="/rankings/guild" style={{ textDecoration: 'none', color: 'inherit' }}>Guild</Link></li>
                            </ul>
                        </li>

                        <li>
                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                to="/informacion"
                            >
                                <Typography style={{ fontSize: 12, color:'#000', fontWeight:500 , fontFamily: 'poppins', whiteSpace:'nowrap'}}>Información</Typography>
                            </Link>
                        </li>

                        <li>
                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                to="/ayuda"
                            >
                                <Typography style={{ fontSize: 12 , color:'#000', fontWeight:500, fontFamily: 'poppins', whiteSpace:'nowrap'}}>Ayuda</Typography>
                            </Link>
                        </li>

                        {
                            props.isMobile && !user?.username &&
                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                to="/authenticate"
                            >
                                <Typography style={{ fontSize: 12 , color:'#000', fontWeight:500, fontFamily: 'poppins', whiteSpace:'nowrap'}}>
                                    Ingresar
                                </Typography>
                            </Link>
                        }

                        {
                            props.isMobile && !user?.username &&
                            <Link
                                style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                to="/registro"
                            >
                                <Typography style={{ fontSize: 12 , color:'#000', fontWeight:500, fontFamily: 'poppins', whiteSpace:'nowrap'}}>
                                    Crear cuenta
                                </Typography>
                            </Link>
                        }
                    </ul>

                </Grid>

                <Grid style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-end' }}>

                    <Grid style={{ display: 'flex', alignItems: 'center', borderRight: '1px solid #54595F', gap: '10px', paddingRight: 10 }}>

                        <li style={{ color: 'white', display: 'flex', gap: '5px', alignItems: 'center' }}>
                            {generalData && generalData.jugadoresOnline > 0 ? (
                                <span id="pulsatingDot" style={{ marginRight: '5px' }} />
                            ) : (
                                <span id="pulsatingDotOff" style={{ marginRight: '5px' }} />
                            )}

                            {generalData && generalData.jugadoresOnline > 0 ? (
                                <span style={{ color: 'white', backgroundColor: '#25ff1e', borderRadius: '7px', fontSize: '14px', padding: 3 }}>Online</span>
                            ) : (
                                <span style={{ color: '#ffffff99', backgroundColor: 'red', borderRadius: '7px', fontSize: '14px', padding: 3 }}>Mantenimiento</span>
                            )}
                        </li>
                        {modoOscuro ?
                            <IoIosSunny style={{ fontSize: '16px' }} onClick={() => setModoOscuro(!modoOscuro)} />

                            :
                            <FaMoon style={{ fontSize: '16px' }} onClick={() => setModoOscuro(!modoOscuro)} />
                        }
                    </Grid>



                    {!props.isMobile ?
                        !user?.username ?
                            <Grid style={{ display: "flex", alignItems: "center", gap: "10px", padding: 10, justifyContent: 'center' }}>
                                <Grid style={{ display: 'flex', alignItems: 'center', borderRight: '1px solid #54595F', gap: '10px', paddingRight: 10 }}>

                                    <Link
                                        style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                        to="/authenticate"
                                    >
                                        <Typography style={{ fontSize: 12, fontFamily:'poppins', whiteSpace:'nowrap', fontWeight:300 }}>
                                            Ingresar
                                        </Typography>
                                    </Link>
                                    <Link
                                        style={{ textDecoration: "none", margin: '0 auto', color: 'inherit' }}
                                        to="/registro"
                                    >
                                        <Typography style={{ fontSize: 12 , fontFamily:'poppins', whiteSpace:'nowrap', fontWeight:300 }}>
                                            Crear cuenta
                                        </Typography>
                                    </Link>
                                </Grid>
                                <Grid style={{ display: "flex", alignItems: "center", gap: "5px", padding: '0px 10px', justifyContent: 'center' }}>
                                    <a href='https://www.facebook.com/MuSerendipia' target='_blank' >

                                        <FaSquareInstagram style={{ color: 'grey', fontSize: '24px' }} />

                                    </a>
                                    <a href='https://discord.com/invite/vzXpnuAHGX' target='_blank' style={{ cursor: 'pointer' }} >

                                        <IoLogoDiscord style={{ color: 'grey', fontSize: '24px' }} />

                                    </a>
                                </Grid>
                            </Grid>

                            :

                            <Grid style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <Grid style={{ display: "flex", alignItems: "center", gap: "5px", padding: '0px 10px', justifyContent: 'center' }}>
                                    <a href='https://www.facebook.com/MuSerendipia' target='_blank' >

                                        <FaSquareInstagram style={{ color: 'grey', fontSize: '24px' }} />

                                    </a>
                                    <a href='https://discord.com/invite/vzXpnuAHGX' target='_blank' style={{ cursor: 'pointer' }} >

                                        <IoLogoDiscord style={{ color: 'grey', fontSize: '24px' }} />

                                    </a>
                                </Grid>

                                <div style={{ overflow: 'hidden' }}>


                                    <div
                                        style={{
                                            width: "60px",
                                            height: "60px",
                                            position: "relative",
                                            overflow: 'hidden',
                                            backgroundColor: '#343843',
                                            borderRadius: "50%",
                                        }}
                                        className="navbar-image-avatar"
                                        onClick={(e) => habilitarSubMenu(true, e)}
                                        onMouseEnter={
                                            esClick
                                                ? console.log("activo")
                                                : () => habilitarSubMenu(true)
                                        }
                                        onMouseLeave={
                                            esClick
                                                ? console.log("activo")
                                                : () => habilitarSubMenu(false)
                                        }
                                    >
                                        <img
                                            style={{ width: '100%' }}
                                            src={props.user?.Avatar ?? logoFooter}
                                            alt=""
                                        />
                                    </div>


                                </div>

                            </Grid>

                        :
                        <Grid style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

                            <div onClick={toggleMobileMenu} style={{ cursor: 'pointer' }}>
                                {menuOpen ? <IoMdClose size={30} /> : <IoMdMenu size={30} />}
                            </div>
                            {
                                user?.username &&
                                <div style={{ overflow: 'hidden' }}>


                                    <div
                                        style={{
                                            width: "45px",
                                            height: "45px",
                                            position: "relative",
                                            overflow: 'hidden',
                                            backgroundColor: '#343843',
                                            borderRadius: "50%",
                                        }}
                                        className="navbar-image-avatar"
                                        onClick={(e) => habilitarSubMenu(true, e)}
                                        onMouseEnter={
                                            esClick
                                                ? console.log("activo")
                                                : () => habilitarSubMenu(true)
                                        }
                                        onMouseLeave={
                                            esClick
                                                ? console.log("activo")
                                                : () => habilitarSubMenu(false)
                                        }
                                    >
                                        <img
                                            style={{ width: '100%' }}
                                            src={props.user?.Avatar ?? logoFooter}
                                            alt=""
                                        />
                                    </div>


                                </div>}
                        </Grid>
                    }
                    {subMenu && (
                        <Grid
                            onMouseEnter={
                                esClick
                                    ? console.log("activo")
                                    : () => habilitarSubMenu(true)
                            }
                            onMouseLeave={
                                esClick
                                    ? console.log("activo")
                                    : () => habilitarSubMenu(false)
                            }
                            style={{
                                backgroundColor: "#121418",
                                border: "1px solid #343843",
                                position: "absolute",
                                padding: "1rem",
                                width: "16.25rem",
                                right: props.isMobile ? '0' : "14%",
                                top: props.isMobile ? '10%' : "15%",
                                borderRadius: "0.5rem",
                                zIndex: 99999,
                            }}
                        >
                            <Grid
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "15px",
                                    marginTop: "15px",
                                }}
                            >
                                <Grid
                                    style={{
                                        backgroundColor: "#202329",
                                        borderRadius: "5px",
                                        display: "flex",
                                        flexDirection: "column",
                                        padding: "1rem",
                                        width: "100%",
                                    }}
                                >
                                    <Grid
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "15px",
                                            padding: 10,
                                        }}
                                    >
                                        <img
                                            src={props.user?.Avatar ?? logoFooter}
                                            alt=""
                                            style={{
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                        />
                                        <Grid
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "1px",
                                            }}
                                        >
                                            <Link
                                                style={{
                                                    textDecoration: "none",
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                                to={"/" + user?.username}
                                            >
                                                <Typography
                                                    style={{
                                                        color: "white",
                                                        fontSize: "1rem",
                                                        fontFamily: "Inter",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {user?.username ?? "Usuario"}
                                                </Typography>
                                            </Link>

                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Link
                                    className="dropdownaccount-link"
                                    to={"/" + user?.username}
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <AiOutlineUser style={{ marginRight: "10px" }} />
                                    Mi Cuenta
                                </Link>
                                <Link
                                    className="dropdownaccount-link"
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                    to={"/" + user?.username + "/galeria"}
                                >
                                    <GrGallery style={{ marginRight: "10px" }} />
                                    Galeria
                                </Link>
                                <Link
                                    className="dropdownaccount-link"
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                    to={"/" + user?.username + "/settings"}
                                >
                                    <AiOutlineSetting style={{ marginRight: "10px" }} />
                                    Configuración
                                </Link>
                                <div
                                    className="dropdownaccount-link"
                                    onClick={() => handleLogout()}
                                    style={{ display: "flex", alignItems: 'center' }}
                                >
                                    <TbLogout2 style={{ marginRight: "10px", color: 'white' }} />
                                    <Typography style={{ color: 'white' }}>
                                        Cerrar sesión
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>
                    )}
                </Grid>

            </Grid>



            <Swiper
                spaceBetween={5}
                slidesPerView={
                    imagenes.length < 5 ? imagenes.length : (props.isMobile ? 5 : 3)
                }
                loop={imagenes.length > (props.isMobile ? 5 : 3)}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                style={{
                    marginTop: 10,
                    padding: 15,
                    borderRadius: 5,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    width: '100%',
                    gap: '10px',
                }}
            >
                {imagenes.map((i, index) => (
                    <SwiperSlide key={i.url} style={{ display: 'flex', justifyContent: 'center' }}>
                        <img
                            src={i?.url}
                            onClick={() => openImage(i.url)}
                            alt={`logo-${i.usuario}`}
                            style={{
                                borderRadius: '50%',
                                width: '80px',
                                height: '80px',
                                objectFit: 'cover',
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>


            {isOpen && selectedImage && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                    }}
                >
                    {/* Botón X para cerrar */}
                    <button
                        onClick={closeImage}
                        style={{
                            position: 'absolute',
                            top: 20,
                            right: 20,
                            background: 'transparent',
                            border: 'none',
                            fontSize: '32px',
                            color: '#fff',
                            cursor: 'pointer',
                            zIndex: 1001,
                        }}
                        aria-label="Cerrar visor"
                    >
                        &times;
                    </button>

                    {/* Imagen ampliada */}
                    <img
                        src={selectedImage}
                        alt="Expanded"
                        style={{
                            maxWidth: '90%',
                            maxHeight: '90%',
                            borderRadius: 10,
                            boxShadow: '0 0 20px rgba(0,0,0,0.5)',
                        }}
                        onClick={(e) => e.stopPropagation()} // evita que se cierre al hacer click sobre la imagen
                    />
                </div>
            )}




            {props.children}


        </Grid >
    )
}

export default Nlayout